import React, { useState } from 'react'
import styled from 'styled-components'

import okButton from '../../assets/addUserScreen/addImage/okButton.png'
import cancelButton from '../../assets/addUserScreen/addImage/cancelButton.png'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'
import outlineFront from '../../assets/addUserScreen/step5/user_outline_front.png'
import outlineSide from '../../assets/addUserScreen/step5/user_outline_side.png'

const AddImageContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    (props.side == 'back' && !props.isThereTempImage && !props.background) ||
    (props.side == 'front' && !props.isThereTempImage && !props.background)
      ? `url(${outlineFront})`
      : !props.isThereTempImage && !props.background
      ? `url(${outlineSide})`
      : `url(${props.background})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 5;
  background-color: ${(props) => (props.background ? `white` : null)};
`

const AddImageInput = styled.input`
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
`

const CameraWrapper = styled.div`
  width: 100%;
  height: 100%;
`

const AgreementsButtonsRow = styled.div`
  display: flex;
  width: ${(props) => (props.absolutePosition ? '30%' : '100%')};
  justify-content: center;
  /* bottom: -40vh; */

  position: ${(props) => (props.absolutePosition ? 'absolute' : 'unset')};
  bottom: ${(props) => (props.absolutePosition ? '10vh' : 'unset')};

  ${mediaQ('mobileAll', 'width: 100%')}
`

const AgreementButton = styled.button`
  width: 80px;
  height: 80px;
  background: ${(props) =>
    props.ok ? `url(${okButton})` : `url(${cancelButton})`};
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
`

const SideLabel = styled.div`
  position: relative;
  top: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  text-transform: uppercase;
  ${fontSizeResponsive(30)};
`

const AddImage = ({
  changeDefaultBackground,
  onImageSave,
  imageUrl,
  side,
  resetBackground,
  onChangeHandler,
  backgroundImage,
  entry,
  background,
  isAgreementButtonsOn,
  saveOriginalImages,
  resetImage,
  absolutePosition,
  setStep,
  step,
  storeData,
  isEditMode,
  photoId,
  isThereTempImage,
  isEditable,
}) => {
  const [shouldUseCamera, setToUseCamera] = useState(false)

  const handleNewEntryModal = () => {
    setStep(step + 1)
    saveOriginalImages(side)

    step == 4 && storeData()
  }
  const sideFormat = (imageSide) => {
    let correctForm
    switch (imageSide) {
      case 'front':
        correctForm = 'PRZÓD'
        return correctForm
      case 'side':
        correctForm = 'BOK'
        return correctForm
      case 'back':
        correctForm = 'TYŁ'
        return correctForm
    }
  }

  return (
    <AddImageContainer
      side={side}
      isThereTempImage={isThereTempImage}
      background={background}
    >
      {side !== undefined &&
        background == undefined &&
        isThereTempImage == false && <SideLabel>{sideFormat(side)} </SideLabel>}
      <CameraWrapper>
        {isEditable && (
          <AddImageInput
            type="file"
            name="file"
            accept="image/x-png,image/gif,image/jpeg"
            // onChange={(e) => onChangeHandler(e, side)}
            onChange={(e) => onImageSave(e, side)}
          />
        )}
      </CameraWrapper>
      {isAgreementButtonsOn && (
        <AgreementsButtonsRow absolutePosition={absolutePosition}>
          <AgreementButton
            ok
            onClick={
              setStep
                ? handleNewEntryModal
                : () => saveOriginalImages(side, isEditable, photoId)
            }
          ></AgreementButton>
          <AgreementButton
            cancel
            onClick={() => resetImage(side)}
          ></AgreementButton>
        </AgreementsButtonsRow>
      )}
    </AddImageContainer>
  )
}
export default AddImage
